<div class="cancel-order dropdown-content-root">
	<div class="dropdown-title">
		<h4 class="title">{{ 'cancelOrder.title' | translate }}</h4>
		<tui-icon
			class="close-icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="content">
		<div class="details">
			<div class="detail">
				<h6 class="title">{{ 'cancelOrder.operation' | translate }}</h6>
				<span
					class="value"
					highlight
					[isPositive]="order?.side === orderSideEnum.BUY"
					[isNegative]="order?.side === orderSideEnum.SELL"
					>{{ 'cancelOrder.side.' + order?.side | translate }}</span
				>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'cancelOrder.ticker' | translate }}</h6>
				<span class="value">{{ order?.symbol }}</span>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'cancelOrder.orderType' | translate }}</h6>
				<span class="value">{{ order | titleOrderType: true }}</span>
			</div>

			@if (isLimitPriceVisible) {
				<div class="detail">
					<h6 class="title">{{ 'cancelOrder.limitPrice' | translate }}</h6>
					<span class="value">{{ order?.limit_price | price }}</span>
				</div>
			}

			@if (isStopPriceVisible) {
				<div class="detail">
					<h6 class="title">{{ 'cancelOrder.stopPrice' | translate }}</h6>
					<span class="value">{{ order?.stop_price | price }}</span>
				</div>
			}

			@if (takeProfit) {
				<div class="detail">
					<h6 class="title">{{ 'cancelOrder.attributes.take_profit' | translate }}</h6>
					<span class="value">{{ takeProfit.limit_price | price }}</span>
				</div>
			}

			@if (stopLoss) {
				<div class="detail">
					<h6 class="title">{{ 'cancelOrder.attributes.stop_loss' | translate }}</h6>
					<span class="value">{{ stopLoss.stop_price | price }}</span>
				</div>
			}

			<div class="detail">
				<h6 class="title">{{ 'cancelOrder.quantity' | translate }}</h6>
				<span class="value">{{ order?.qty | quantity }}</span>
			</div>

			<div class="detail">
				<h6 class="title">{{ 'cancelOrder.orderDuration' | translate }}</h6>
				@if (order) {
					<span class="value">
						{{ 'orders.terms.' + (order.time_in_force | titleOrderTerm: order.extended_hours) | translate }}
					</span>
				}
			</div>
		</div>

		<div class="actions">
			<app-button
				appearance="outline"
				size="l"
				(clicked)="onCloseDropdown()"
			>
				{{ 'cancelOrder.no' | translate }}
			</app-button>
			<app-button
				appearance="negative"
				size="l"
				[isLoading]="isLoading()"
				(clicked)="cancelOrder()"
			>
				{{ 'cancelOrder.yes' | translate }}
			</app-button>
		</div>
	</div>
</div>
